import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { MessageWithId } from "../../store/conversationMessagesSlice";

interface UserMessageProps {
  message: Extract<MessageWithId, { type: "user" }>;
}

export const UserMessage: React.FC<UserMessageProps> = ({ message }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", my: 4 }}>
      <Paper
        sx={{
          p: 2,
          py: 1,
          maxWidth: "70%",
          bgcolor: "primary.main",
          color: "primary.contrastText",
          borderRadius: "24px",
        }}
      >
        <Typography>{message.content.text}</Typography>
      </Paper>
    </Box>
  );
};
